import {clearGeoJsonLayers, removeGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {zoomToLayer} from "@/helpers/ol/ol-zoom-helper";
import {removeMapClickMarker} from "@/helpers/ol/ol-map-click-layer-helper";
import {clearPrint} from "@/helpers/print/print-scales-helper";
import $ from 'jquery'
import {
    addClassBySelector,
    getAllBySelector,
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector
} from "@/helpers/element-helper";
import {clearPrintCesium} from "@/helpers/print/cesium/print-cesium-helper";
import {removeCesiumMarker} from "@/modules/cesium/cesium-marker";
import {stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {unCheckDrawButtons} from "@/helpers/tools/tools-measure-helper";
import {focusMap} from "@/helpers/ol/ol-map-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {isMobile} from "@/helpers/mobile-helper";
import {clearInfo, loadInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {clearToolsMutationSelectLayer} from "@/helpers/tools/tools-mutation-select-layer-helper";
import {clearWordPrint} from "@/helpers/word/word-helper";
import {removeInfoMvt} from "@/modules/ol/service/ol-service-mvt";
import {clearInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {clearFiltersValues, resetFilter} from "@/helpers/filter/filter-settings-helper";
import {getActiveMutation, removeAllDrawings, resetMutation} from "@/helpers/tools/tools-mutation-helper";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper";
import {refreshAllActiveLayers, refreshLayer} from "@/helpers/ol/ol-layer-helper";
import {getDataTableByFormIDAndFeatureID} from "@/helpers/datatable/datatable-standalone-editor-helper";
import {clearPrintSelectLayerItems} from "@/helpers/print/print-helper.js";
import {isCesiumEnabled} from "@/modules/cesium/cesium.js";

export function hideLayerInfoForm(isClear = false, clearGeoJsonLayer = false) {

    const element = document.getElementsByClassName('info-menu-content')[0]

    element.classList.add('d-none')
    element.childNodes.forEach((childNode) => {
        if(childNode.nodeType === 1) {
            childNode.classList.add('d-none')
        }
    })
    // document.getElementsByClassName('info-menu-buttons')[0].classList.add('info-menu-buttons-open')

    if(isClear) {
        // document.getElementsByClassName('info-menu')[0].style.transform = ''
        // document.getElementsByClassName('info-menu')[0].style.height = ''
        // $('.info-menu').css('right', '')
        // $('.info-menu').css('top', '')
        // $('#divInfoMenuButtons').css('right', '')
    } else {
        // $('#divInfoMenuButtons').css('right', '-70px')
    }

    $('.info-menu').css('right', '70px')
    $('.info-menu').css('top', '55px')
    if(clearGeoJsonLayer) {
        clearGeoJsonLayers()
        const result = {}
        result.mainTabs = []
        loadInfo(result)
    }

    hideIconMenuButtonTitles()
}

export function showLayerInfoButton(selector, toggle = true) {

    if(selector !== 'layer-info-info') {
        let width = '35rem'
        if (window.settings.PopupBreedte) {
            width = window.settings.PopupBreedte
        }
        getBySelector('.info-menu').style.width = width
    }

    const element = document.querySelectorAll(selector)[0]
    if(toggle) {
        if(element.classList.contains('d-none')) {
            hideLayerInfoForm(true)
            element.classList.remove('d-none')
            element.parentNode.classList.remove('d-none')
            document.getElementsByClassName('info-menu-buttons')[0].classList.remove('info-menu-buttons-open')
        } else {
            element.classList.add('d-none')
            element.parentNode.classList.add('d-none')
            document.getElementsByClassName('info-menu-buttons')[0].classList.add('info-menu-buttons-open')
            hideLayerInfoForm(true)
        }
    } else {
        hideLayerInfoForm(true)
        element.classList.remove('d-none')
        element.parentNode.classList.remove('d-none')
        document.getElementsByClassName('info-menu-buttons')[0].classList.remove('info-menu-buttons-open')
    }

    checkActiveLayerInfoButtons()

    if(window['tblFilterSettings'] && window['tblFilterSettings'].columns) {
        window['tblFilterSettings'].columns.adjust()
    }
    if(window['tblMutationSettings'] && window['tblMutationSettings'].columns) {
        window['tblMutationSettings'].columns.adjust()
    }
}

export function initHideButton() {
    document.querySelectorAll('.btnHideInfoMenu').forEach((element) => {
        element.addEventListener('click', () => {
            hideAllInfo()
            if(isMobile()) {
                hideElementsBySelector('layer-menu')
            }

            checkActiveLayerInfoButtons()
        });
    })

    document.querySelectorAll('.btnCloseInfoMenu').forEach((element) => {
        const parentElement = element.dataset.parentElement
        element.addEventListener('click', () => {
            closeInfoMenu(parentElement)
        });
    })
}

export function closeInfoMenu(element) {
    hideAllInfo()

    switch (element) {
        case 'layer-info-characteristics':
            clearInfoCharacteristics()
            removeClassBySelector('.btn-characteristics', 'active')
            break;
        case 'layer-info-info':
            clearInfo()
            hideLayerInfoForm(true, true)
            disableMoveLayer()
            refreshAllActiveLayers()
            break;
        case 'layer-info-filter':
            resetFilter()
            stopDraw()

            removeClassBySelector('.btn-filter', 'active')
            removeGeoJsonLayer('filter_mark')
            break;
        case 'layer-info-mutation':
            removeClassBySelector('.btn-mutation', 'active')
            resetMutation()
            break;
        case 'layer-info-tools':
            removeAllDrawings()
            unCheckDrawButtons()
            break;
    }

    checkActiveLayerInfoButtons()
}

export function checkActiveLayerInfoButtons() {
    setTimeout(() => {

        if(getActiveFilter()) {
            addClassBySelector('layer-info-filter-button .info-menu-btn', 'active')
        } else {
            removeClassBySelector('layer-info-filter-button .info-menu-btn', 'active')
        }

        if(getActiveMutation()) {
            addClassBySelector('layer-info-mutation-button .info-menu-btn', 'active')
        } else {
            removeClassBySelector('layer-info-mutation-button .info-menu-btn', 'active')
        }

        if(getBySelector('.nav-tab-characteristics')) {
            addClassBySelector('layer-info-characteristics-button .info-menu-btn', 'active')
        } else {
            removeClassBySelector('layer-info-characteristics-button .info-menu-btn', 'active')
        }

        if(getBySelector('layer-info-info-bread-crumb')) {
            addClassBySelector('layer-info-info-button .info-menu-btn', 'active')
        } else {
            removeClassBySelector('layer-info-info-button .info-menu-btn', 'active')
        }

        if(
            window.drawMeasureVectorSource && window.drawMeasureVectorSource.getFeatures().length > 0 || isCesiumEnabled()

        ) {
            addClassBySelector('layer-info-tools-button .info-menu-btn', 'active')
        } else {
            removeClassBySelector('layer-info-tools-button .info-menu-btn', 'active')
        }

        removeClassBySelector('layer-info-legend-button .info-menu-btn', 'active')
    }, 300)
}

export function hideIconMenuButtonTitles() {
    document.querySelectorAll('.info-menu-btn-title').forEach((element) => {
        element.classList.add('d-none')
    })
}

export function hideAllInfo() {
    hideLayerInfoForm(false, false)
    removeMapClickMarker()
    clearPrint()
    clearWordPrint()
    clearPrintCesium()
    hideIconMenuButtonTitles()
    removeCesiumMarker()
    removeAllActiveClasses()
    clearToolsMutationSelectLayer()
    clearPrintSelectLayerItems()
    delete window.result
}
